var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"well",attrs:{"id":"calendar-index"}},[_c('p',[_vm._v("Choosing a calendar view...")])])
}]

export { render, staticRenderFns }